export const NEWS = {
    INTRO_LIMIT: 3, // Introduction of the news landing page
    BY_CATEGORY_LIMIT: 12, // The search by category section
    // The filter stories carousel, four scrolls of three cards per page. Each
    // page is a slice rather than everything up to it, so the pages stay a
    // constant size and do not repeat each other's articles.
    FILTER_LIMIT: 12,
    // Landing partway through the listing pulls in this many of the pages before
    // it, so the carousel opens with a run of articles rather than a single page.
    // Only once, so arriving deep in the archive does not drag the whole thing in.
    BACKFILL_PAGES: 2,
    // The grid the category pages use in place of the carousel. Its pages are
    // cumulative rather than slices: page 3 is everything up to page 3, because
    // "More stories" adds to what is on screen rather than moving off it, and the
    // URL it leaves behind has to reproduce that.
    GRID_LIMIT: 9,
    // Cards per row at the widest breakpoint. The grid only ever renders whole
    // rows, so this is what decides how many of the articles fetched are held back
    // until the row they would start can be filled.
    GRID_COLUMNS: 3,
    // A level 2 category whose CMS entry picks out exactly this many featured
    // stories opens with them across two thirds of the row instead of a plain
    // grid. Anything else falls back to the grid, so the layout is only used
    // where it fits the row exactly.
    FEATURE_ITEMS: 2,
    // Articles the feature row takes out of the listing to fill the third the
    // featured stories leave. One short column of the grid's own cards, so the
    // remainder still divides into whole rows of GRID_COLUMNS.
    FEATURE_LEAD: 3,
    // The search index refuses an offset past this, and answers with a 500
    // rather than an empty result, so page numbers are clamped to fit inside it
    RESULT_WINDOW: 10000,
    CATEGORY_ALL: {
        name: 'Auckland Zoo',
        id: 'all'
    },
    DISPLAY_TYPES: {
        FEATURED: 'featured-article',
        EXTENDED: 'extended-article'
    }
};
